import { Box, Container } from '@mui/material'
import React from 'react'
import epicore from "../../Assets/CatalogFooterLogo/Epicore.png";
import klipboard from "../../Assets/CatalogFooterLogo/Klipboard.png";
import nextPart from "../../Assets/CatalogFooterLogo/nexpart-whi.png";
import partsTech from "../../Assets/CatalogFooterLogo/PartsTech.png";

export const CatalogLogo = () => {
  return (
    <Box className="footer_container" sx={{width: "100%", display: "flex", flexDirection: "column",}}>
        <Box className="footer_maincontainer" sx={{width: "100%", height: "auto", display: "flex", flexDirection: "column", gap: 2}}>
            <Container>
                <Box className="catalog_logo_main" sx={{width:"100%", display: "flex", flexDirection: "row", gap: "45px",}}>
                    <img src={epicore} alt="Epicor" className='cat-logo-in'/>
                    <img src={klipboard} alt="Klipboard" className='cat-logo-in' />
                    <img src={partsTech} alt="PartsTech" className='cat-logo-in' />
                    <img src={nextPart} alt="NextPart" className='cat-logo-in' />
                </Box>
            </Container>
        </Box>
     </Box>
  )
}
